<template>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('Project manager review') }}</span>
        </v-card-title>
        <v-card-text>
          <alert/>
          <v-form
              ref="formAdminReview"
              v-model="valid"
              lazy-validation
            >
            <div v-for="(item, index) in ratings" :key="`rating-${index}`">
              <v-row dense>
                  <v-col cols="12" md="6" align-self="center">
                      {{ $t(item.text) }}
                  </v-col>
                  <v-col cols="12" md="6">
                      <v-rating
                        hover
                        length="5"
                        size="30"
                        v-model="form.review[item.value]"
                        background-color="orange lighten-3"
                        color="orange"
                        half-increments
                        :readonly="!canSubmit"
                      />
                  </v-col>
              </v-row>
              <v-divider class="my-3"/>
            </div>
            <v-row dense>
              <v-col cols="12" md="6" align-self="center">
                    {{ $t('Total (Average)') }}
                </v-col>
                <v-col cols="12" md="6">
                    <strong>{{ average }}</strong>
                </v-col>
            </v-row>
            <v-divider class="my-3"/>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-center pb-5">
          <v-btn
            color="secondary"
            @click="close"
          >
            {{ $t('Close') }}
          </v-btn>
          <v-btn
            v-if="canSubmit"
            color="primary"
            dark
            :disabled="disabled"
            @click="submit"
          >
            {{ $t('Submit') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import Alert from '@components/Alert'
import Validation from '@utils/validation'
import { call } from 'vuex-pathify'

export default {
  name: 'DialogAdminReview',
  components: {
    Alert
  },
  data() {
    return {
      dialog: false,
      disabled: false,
      canSubmit: false,

      valid: true,
      ratings: [
        {
          value: 'time_management',
          text: 'Time management'
        },
        {
          value: 'economic',
          text: 'Economic evaluation'
        },
        {
          value: 'technical',
          text: 'Technical evaluation'
        },
        {
          value: 'team_working',
          text: 'Team working'
        },
        {
          value: 'creativity',
          text: 'Creativity'
        }
      ],
      form: {
        id: '',
        value: '',
        review: {
          time_management: 0,
          economic: 0,
          technical: 0,
          team_working: 0,
          creativity: 0
        }
      },
      rules: {
        value: [
          (v) => Validation.required(v),
          (v) => Validation.number(v),
          (v) => Validation.min(v, 0)
        ]
      }
    }
  },
  computed: {
    average() {
      let total = 0
      let totalCase = 0
      const myObj = {
        ...this.form.review
      }
      Object.keys(myObj).forEach(key => {
        total += myObj[key]
        totalCase++
      })
      return total / totalCase
    }
  },

  methods: {
    handleSubmit: call('task/managerReview'),
    hideAlert: call('alert/hide'),
    loading: call('app/setLoading'),
    showNotify: call('notify/show'),

    setData(item) {
      const defaultFormReview = {
        time_management: item.manager_review?.time_management || 0,
        economic: item.manager_review?.economic || 0,
        technical: item.manager_review?.technical || 0,
        team_working: item.manager_review?.team_working || 0,
        creativity: item.manager_review?.creativity || 0
      }
      this.$set(this, 'form', {
        id: item.id,
        review: {
          ...defaultFormReview
        }
      })
      this.disabled = false
      this.canSubmit = ['completed'].includes(item.status)
      this.dialog = true
    },
    async submit(e) {
      e.preventDefault()

      const formValid = this.$refs.formAdminReview.validate()
      if (!formValid) {
        alert(this.$t('Please check data before submit!'))
      } else {
        let reviewError = false
        for (const key in this.form.review) {
          if (parseInt(this.form.review[key]) === 0) {
            reviewError = true
            break
          }
        }
        if (reviewError) {
          alert(this.$t('Please select your rating.'))
          return false
        }
        this.disabled = true
        this.hideAlert()
        this.loading(true)
        const res = await this.handleSubmit({
          ...this.form
        })
        this.loading(false)
        if (!res) {
          this.disabled = false
        } else {
          this.$emit('submit', res.data.task)
          this.showNotify(res.message)
          this.dialog = false
        }
      }
    },

    close(e) {
      e.preventDefault()
      this.dialog = false
    }
  }
}
</script>
